const USER = 'Choose a user below'
const CUSTOMERS = 'All Customers'
const NEXT = 'Next'

export { USER, CUSTOMERS, NEXT }
